import React from 'react';
import {Icon} from '../Icon/Icon';
import './styles.css';

interface Props {
  title: string;
  subtitle: string;
}

const FeedbackEmptyState = ({title, subtitle}: Props) => {
  return (
    <div className="EmptyStateContainer">
      <Icon name="feedback-menu.svg" className="SpanIcon" />
      <p className="Title">{title}</p>
      <p className="Title">{subtitle}</p>
    </div>
  );
};

export default FeedbackEmptyState;
